<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasRoleRequisicao"
             color="primary"
             class="rounded-tag-small normal-btn-text elevation-0"
             link to="/cadastro-requisicao">
        <v-icon left>mdi-plus</v-icon>
        Solicitação
      </v-btn>
      <v-btn v-if="hasModuleGerencia"
             class="rounded-tag-small normal-btn-text elevation-0 ml-3"
             link to="/requisicoes/gerar">
        <v-icon>mdi-format-list-bulleted</v-icon>
         Agrupar Solicitações
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-listagem-requisicao-filtros @change="emitChange" />
      <px-search-text class="rounded-tag-small"
                      label="Busque por solicitante, empresa ou identificador"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListagemRequisicaoFiltros from './ListagemRequisicaoFiltros.vue';

export default {
  data() {
    return {
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        {
          id: 'RASCUNHO',
          description: 'Rascunhos',
          value: ['RASCUNHO'],
        },
        {
          id: 'ABERTAS',
          description: 'Abertas',
          value: ['RECEBIDA', 'EM_COTACAO'],
        },
        {
          id: 'CANCELADAS',
          description: 'Canceladas',
          value: ['CANCELADA'],
        },
        {
          id: 'FINALIZADAS',
          description: 'Finalizadas',
          value: ['FINALIZADA'],
        },
      ],
    };
  },
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia', 'hasRoleRequisicao']),
    selectedStatus: {
      get() {
        return this.$store.getters['listagemRequisicao/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemRequisicao/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemRequisicao/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemRequisicao/searchText', searchText);
      },
    },
  },
  created() {
    if (!this.selectedStatus) {
      [this.selectedStatus] = this.statusOptions;
    }
  },
  components: {
    pxListagemRequisicaoFiltros: ListagemRequisicaoFiltros,
  },
};
</script>
